module.exports = __webpack_public_path__ + "static/media/banner-img-4.2943d76c.png";